export const decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions" as const;
